let host = window.location.host;
let SITE_API__ = "";
let API__ = "";
let FILE_BASE_URL__ = "";
let FILE_MAKER_SERVER_BASE_URL__ = "";

if (host == "crm.consultified.com") {
    SITE_API__ = "https://api.consultified.com/api";
    API__ = "https://crm.api.consultified.com/api";
    FILE_BASE_URL__ = "https://storage.googleapis.com/consultified_media/production/";
    FILE_MAKER_SERVER_BASE_URL__ = "https://api.meritios.com/node";
}
else if (host == "dev.crm.consultified.com") {
    SITE_API__ = "https://api.dev.consultified.com/api";
    API__ = "https://crm.api.dev.consultified.com/api";
    FILE_BASE_URL__ = "https://storage.googleapis.com/consultified_media/production/";
    FILE_MAKER_SERVER_BASE_URL__ = "https://api.dev.meritios.com/node";
}
else if (host == "staging.crm.consultified.com") {
    SITE_API__ = "https://api.staging.consultified.com/api";
    API__ = "https://crm.api.staging.consultified.com/api";
    FILE_BASE_URL__ = "https://storage.googleapis.com/consultified_media/production/";
    FILE_MAKER_SERVER_BASE_URL__ = "https://api.staging.meritios.com/node";
}
else if (host.startsWith("localhost")) {
    SITE_API__ = "https://api.dev.consultified.com/api";
    API__ = "https://crm.api.dev.consultified.com/api";
    FILE_BASE_URL__ = "https://storage.googleapis.com/consultified_media/production/";
    FILE_MAKER_SERVER_BASE_URL__ = "https://api.dev.meritios.com/node";
} else {
    SITE_API__ = "https://api.dev.consultified.com/api";
    API__ = "https://crm.api.dev.consultified.com/api";
    FILE_BASE_URL__ = "https://storage.googleapis.com/consultified_media/production/";
    FILE_MAKER_SERVER_BASE_URL__ = "https://api.dev.meritios.com/node";
}

export const SITE_API_ = SITE_API__;
export const API_ = API__;
export const FILE_BASE_URL_ = FILE_BASE_URL__;
export const FILE_MAKER_SERVER_BASE_URL_ = FILE_MAKER_SERVER_BASE_URL__;